import { render, staticRenderFns } from "./TodoWindowView.vue?vue&type=template&id=f3e2c372&scoped=true&"
import script from "./TodoWindowView.vue?vue&type=script&lang=js&"
export * from "./TodoWindowView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e2c372",
  null
  
)

export default component.exports